<lib-dialog-layout>
    @if (data === EditRecurringOption.ThisAndFuture) {
        <ng-container title i18n="@@CommonUpdateFutureEntriesDialogTitle">
            Update Future Entries
        </ng-container>
    } @else if (data === EditRecurringOption.ThisOnly) {
        <ng-container title i18n="@@CommonUpdateThisEntryOnlyDialogTitle">
            Update This Entry Only
        </ng-container>
    } @else {
        <ng-container title i18n="@@CommonUpdateRecurringEntriesDialogTitle">
            Update Recurring Entries
        </ng-container>
    }

    @if (data === EditRecurringOption.ThisAndFuture) {
        <p content i18n="@@CommonUpdateFutureEntriesDialogDescription">
            Changing the recurrence will update all future entries.
        </p>
    } @else if (data === EditRecurringOption.ThisOnly) {
        <p content i18n="@@CommonUpdateThisEntryOnlyDialogDescriptionNew">
            Changing the date will affect this entry only.
        </p>
    } @else {
        <ng-container content>
            <lib-radio-group
                [formControl]="form.controls.ApplyToFutureEntries">
                <lib-radio-group-item
                    [value]="EditRecurringOption.ThisOnly"
                    i18n="@@CommonEditRecurringEntriesDialogOnlyThisEntryOption">
                    This entry only
                </lib-radio-group-item>
                <lib-radio-group-item
                    [value]="EditRecurringOption.ThisAndFuture"
                    i18n="@@CommonEditRecurringEntriesDialogThisAndFollowingEntriesOption">
                    This and following entries
                </lib-radio-group-item>
            </lib-radio-group>
        </ng-container>
    } 

    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
            <lib-button
            [role]="ButtonRole.Primary"
                (clicked)="PrimaryAction()">
                <ng-container label i18n="@@CommonUpdateButton">
                    Update 
                </ng-container>
            </lib-button>
            <lib-button
            [role]="ButtonRole.Secondary"
                [kind]="ButtonKind.NeutralSecondary"
                (clicked)="DismissAction()">
                <ng-container label i18n="@@CommonCancelButton">
                    Cancel
                </ng-container>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>
